import { createRouter, createWebHistory } from 'vue-router'

// Lazy load components
const Home = () => import('../pages/home/Home.vue')
const Login = () => import('../pages/login/Login.vue')
const Register = () => import('../pages/register/Register.vue')
const ForgotPassword = () => import('../pages/forgotPassword/ForgotPassword.vue')
const ForgotLoginName = () => import('../pages/forgotLoginName/ForgotLoginName.vue')
const Account = () => import('../pages/user/account/Account.vue')
const Recharge = () => import('../pages/user/recharge/Recharge.vue')
const RechargeInfo_1 = () => import('../pages/user/recharge/RechargeInfo_1.vue')
const RechargeInfo_2 = () => import('../pages/user/recharge/RechargeInfo_2.vue')
const RechargeInfo_3 = () => import('../pages/user/recharge/RechargeInfo_3.vue')
const Withdraw = () => import('../pages/user/withdraw/Withdraw.vue')
const Trading = () => import('../pages/trading/Trading.vue')
const TradingDirection = () => import('../pages/trading/TradingDirection.vue')
const Kline = () => import('../pages/kline/Kline.vue')
const Quotes = () => import('../pages/quotes/Quotes.vue')
const SearchQuotes = () => import('../pages/quotes/SearchQuotes.vue')
const QuotesDetails = () => import('../pages/quotes/QuotesDetails.vue')
const FoundWinner = () => import('../pages/foundWinner/FoundWinner.vue')
const CapitalAccount = () => import('../pages/capital/CapitalAccount.vue')
const CapitalAccountDetails = () => import('../pages/capital/CapitalAccountDetails.vue')
const CapitalFundDetails = () => import('../pages/capital/CapitalFundDetails.vue')
const ClosedCapitalInfo = () => import('../pages/capital/ClosedCapitalInfo.vue')
const IncreaseInfo = () => import('../pages/capital/IncreaseInfo.vue')
const TimeBao = () => import('../pages/user/timebao/TimeBao.vue')
const TimeBaoDetails = () => import('../pages/user/timebao/TimeBaoDetails.vue')
const Protocol = () => import('../pages/protocol/Protocol.vue')
const Activity = () => import('../pages/activity/activity.vue')
const ActivityDetail = () => import('../pages/activity/ActivityDetail.vue')
const AllNews = () => import('../pages/news/AllNews.vue')
const NewsDetails = () => import('../pages/news/NewsDetails.vue')
const NewsInfo = () => import('../pages/news/NewsInfo.vue')
const Announcement = () => import('../pages/user/announcement/Announcement.vue')
const AnnouncementDetail = () => import('../pages/user/announcement/AnnouncementDetail.vue')
const MemberInformation = () => import('../pages/user/memberInformation/MemberInformation.vue')
const MemberDetailedLog = () => import('../pages/user/memberInformation/MemberDetailedLog.vue')
const PositionInquiry = () => import('../pages/user/inquiry/PositionInquiry.vue')
const DealInquiry = () => import('../pages/user/inquiry/DealInquiry.vue')
const EntrustInquiry = () => import('../pages/user/inquiry/EntrustInquiry.vue')
const WithdrawalInquiry = () => import('../pages/user/inquiry/WithdrawalInquiry.vue')
const AboutUs = () => import('../pages/aboutus/aboutusdetails.vue')
const RiskControl = () => import('../pages/user/riskControl/RiskControl.vue')
const ModifyNickname = () => import('../pages/user/memberInformation/update/ModifyNickname.vue')
const ModifyRealname = () => import('../pages/user/memberInformation/update/ModifyRealname.vue')
const ModifyBank = () => import('../pages/user/memberInformation/update/ModifyBank.vue')
const ModifyPhone = () => import('../pages/user/memberInformation/update/ModifyPhone.vue')
const ModifyEmail = () => import('../pages/user/memberInformation/update/ModifyEmail.vue')
const ModifyLoginPassword = () => import('../pages/user/memberInformation/update/ModifyLoginPassword.vue')
const ModifyWithdrawPassword = () => import('../pages/user/memberInformation/update/ModifyWithdrawPassword.vue')
const Agency = () => import('../pages/user/agency/Agency.vue')
const AgentDepot = () => import('../pages/user/agency/AgentDepot.vue')
const AgentTransferWithdraw = () => import('../pages/user/agency/AgentTransferWithdraw.vue')
const AgencyLink = () => import('../pages/user/agency/AgencyLink.vue')
const MyTeam = () => import('../pages/user/agency/MyTeam.vue')
const LowerLevelDepot = () => import('../pages/user/agency/LowerLevelDepot.vue')
const FriendCoupon = () => import('../pages/user/friendCoupon/FriendCoupon.vue')
const FriendCouponTerms = () => import('../pages/user/friendCoupon/FriendCouponTerms.vue')
const FriendCouponQR = () => import('../pages/user/friendCoupon/FriendCouponQR.vue')
const UserCoupon = () => import('../pages/user/userCoupon/UserCoupon.vue')
const NoticeDetailed = () => import('../pages/home/NoticeDetailed.vue')
const ChatList = () => import('../pages/chat/ChatList.vue')
const Chat = () => import('../pages/chat/Chat.vue')
const AppDownload = () => import('../pages/appdownload/AppDownload.vue')
const RedEnvelope = () => import('../pages/user/redenvelope/RedEnvelope.vue')
const Gxpay = () => import('../pages/user/gxpay/Gxpay.vue')
const BackupAPIPage = () => import('../pages/backupAPIPage/backupapipage.vue')
const RiskNotice = () => import('../pages/RiskNotice/RiskNotice.vue')

const routes = [
  {
    path: '/',
    redirect: '/pages/home/Home'
  },
  {
    path: '/pages/home/Home',
    name: 'Home',
    component: Home,
    meta: {
      navigationStyle: 'custom',
      title: 'Home'
    }
  },
  {
    path: '/pages/login/Login',
    name: 'Login',
    component: Login,
    meta: {
      navigationStyle: 'custom',
      title: 'Login'
    }
  },
  {
    path: '/pages/register/Register',
    name: 'Register',
    component: Register,
    meta: {
      navigationStyle: 'custom',
      title: 'Register'
    }
  },
  {
    path: '/pages/forgotPassword/ForgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      navigationStyle: 'custom',
      title: 'Forgot Password'
    }
  },
  {
    path: '/pages/forgotLoginName/ForgotLoginName',
    name: 'ForgotLoginName',
    component: ForgotLoginName,
    meta: {
      navigationStyle: 'custom',
      title: 'Forgot Login Name'
    }
  },
  {
    path: '/pages/user/account/Account',
    name: 'Account',
    component: Account,
    meta: {
      navigationStyle: 'custom',
      title: 'Account',
      enablePullDownRefresh: true
    }
  },
  {
    path: '/pages/user/recharge/Recharge',
    name: 'Recharge',
    component: Recharge,
    meta: {
      navigationStyle: 'custom',
      title: 'Recharge'
    }
  },
  {
    path: '/pages/user/recharge/RechargeInfo_1',
    name: 'RechargeInfo_1',
    component: RechargeInfo_1,
    meta: {
      navigationStyle: 'custom',
      title: 'Recharge Info 1'
    }
  },
  {
    path: '/pages/user/recharge/RechargeInfo_2',
    name: 'RechargeInfo_2',
    component: RechargeInfo_2,
    meta: {
      navigationStyle: 'custom',
      title: 'Recharge Info 2'
    }
  },
  {
    path: '/pages/user/recharge/RechargeInfo_3',
    name: 'RechargeInfo_3',
    component: RechargeInfo_3,
    meta: {
      navigationStyle: 'custom',
      title: 'Recharge Info 3'
    }
  },
  {
    path: '/pages/user/withdraw/Withdraw',
    name: 'Withdraw',
    component: Withdraw,
    meta: {
      navigationStyle: 'custom',
      title: 'Withdraw'
    }
  },
  {
    path: '/pages/trading/Trading',
    name: 'Trading',
    component: Trading,
    meta: {
      navigationStyle: 'custom',
      title: 'Trading'
    }
  },
  {
    path: '/pages/trading/TradingDirection',
    name: 'TradingDirection',
    component: TradingDirection,
    meta: {
      navigationStyle: 'custom',
      title: 'Trading Direction'
    }
  },
  {
    path: '/pages/kline/Kline',
    name: 'Kline',
    component: Kline,
    meta: {
      navigationStyle: 'custom',
      title: 'Kline'
    }
  },
  {
    path: '/pages/quotes/Quotes',
    name: 'Quotes',
    component: Quotes,
    meta: {
      navigationStyle: 'custom',
      title: 'Quotes'
    }
  },
  {
    path: '/pages/quotes/SearchQuotes',
    name: 'SearchQuotes',
    component: SearchQuotes,
    meta: {
      navigationStyle: 'custom',
      title: 'Search Quotes'
    }
  },
  {
    path: '/pages/quotes/QuotesDetails',
    name: 'QuotesDetails',
    component: QuotesDetails,
    meta: {
      navigationStyle: 'custom',
      title: 'Quotes Details'
    }
  },
  {
    path: '/pages/foundWinner/FoundWinner',
    name: 'FoundWinner',
    component: FoundWinner,
    meta: {
      navigationStyle: 'custom',
      title: 'Found Winner'
    }
  },
  {
    path: '/pages/capital/CapitalAccount',
    name: 'CapitalAccount',
    component: CapitalAccount,
    meta: {
      navigationStyle: 'custom',
      title: 'Capital Account'
    }
  },
  {
    path: '/pages/capital/CapitalAccountDetails',
    name: 'CapitalAccountDetails',
    component: CapitalAccountDetails,
    meta: {
      navigationStyle: 'custom',
      title: 'Capital Account Details'
    }
  },
  {
    path: '/pages/capital/CapitalFundDetails',
    name: 'CapitalFundDetails',
    component: CapitalFundDetails,
    meta: {
      navigationStyle: 'custom',
      title: 'Capital Fund Details'
    }
  },
  {
    path: '/pages/capital/ClosedCapitalInfo',
    name: 'ClosedCapitalInfo',
    component: ClosedCapitalInfo,
    meta: {
      navigationStyle: 'custom',
      title: 'Closed Capital Info'
    }
  },
  {
    path: '/pages/capital/IncreaseInfo',
    name: 'IncreaseInfo',
    component: IncreaseInfo,
    meta: {
      navigationStyle: 'custom',
      title: 'Increase Info'
    }
  },
  {
    path: '/pages/user/timebao/TimeBao',
    name: 'TimeBao',
    component: TimeBao,
    meta: {
      navigationStyle: 'custom',
      title: 'Time Bao',
      enablePullDownRefresh: true
    }
  },
  {
    path: '/pages/user/timebao/TimeBaoDetails',
    name: 'TimeBaoDetails',
    component: TimeBaoDetails,
    meta: {
      navigationStyle: 'custom',
      title: 'Time Bao Details',
      enablePullDownRefresh: true
    }
  },
  {
    path: '/pages/protocol/Protocol',
    name: 'Protocol',
    component: Protocol,
    meta: {
      navigationStyle: 'custom',
      title: 'Protocol'
    }
  },
  {
    path: '/pages/activity/activity',
    name: 'Activity',
    component: Activity,
    meta: {
      navigationStyle: 'custom',
      title: 'Activity'
    }
  },
  {
    path: '/pages/activity/ActivityDetail',
    name: 'ActivityDetail',
    component: ActivityDetail,
    meta: {
      navigationStyle: 'custom',
      title: 'Activity Detail'
    }
  },
  {
    path: '/pages/news/AllNews',
    name: 'AllNews',
    component: AllNews,
    meta: {
      navigationStyle: 'custom',
      title: 'All News'
    }
  },
  {
    path: '/pages/news/NewsDetails',
    name: 'NewsDetails',
    component: NewsDetails,
    meta: {
      navigationStyle: 'custom',
      title: 'News Details'
    }
  },
  {
    path: '/pages/news/NewsInfo',
    name: 'NewsInfo',
    component: NewsInfo,
    meta: {
      navigationStyle: 'custom',
      title: 'News Info'
    }
  },
  {
    path: '/pages/user/announcement/Announcement',
    name: 'Announcement',
    component: Announcement,
    meta: {
      navigationStyle: 'custom',
      title: 'Announcement'
    }
  },
  {
    path: '/pages/user/announcement/AnnouncementDetail',
    name: 'AnnouncementDetail',
    component: AnnouncementDetail,
    meta: {
      navigationStyle: 'custom',
      title: 'Announcement Detail'
    }
  },
  {
    path: '/pages/user/memberInformation/MemberInformation',
    name: 'MemberInformation',
    component: MemberInformation,
    meta: {
      navigationStyle: 'custom',
      title: 'Member Information'
    }
  },
  {
    path: '/pages/user/memberInformation/MemberDetailedLog',
    name: 'MemberDetailedLog',
    component: MemberDetailedLog,
    meta: {
      navigationStyle: 'custom',
      title: 'Member Detailed Log',
      enablePullDownRefresh: true
    }
  },
  {
    path: '/pages/user/inquiry/PositionInquiry',
    name: 'PositionInquiry',
    component: PositionInquiry,
    meta: {
      navigationStyle: 'custom',
      title: 'Position Inquiry'
    }
  },
  {
    path: '/pages/user/inquiry/DealInquiry',
    name: 'DealInquiry',
    component: DealInquiry,
    meta: {
      navigationStyle: 'custom',
      title: 'Deal Inquiry'
    }
  },
  {
    path: '/pages/user/inquiry/EntrustInquiry',
    name: 'EntrustInquiry',
    component: EntrustInquiry,
    meta: {
      navigationStyle: 'custom',
      title: 'Entrust Inquiry'
    }
  },
  {
    path: '/pages/user/inquiry/WithdrawalInquiry',
    name: 'WithdrawalInquiry',
    component: WithdrawalInquiry,
    meta: {
      navigationStyle: 'custom',
      title: 'Withdrawal Inquiry'
    }
  },
  {
    path: '/pages/aboutus/aboutusdetails',
    name: 'AboutUs',
    component: AboutUs,
    meta: {
      navigationStyle: 'custom',
      title: 'About Us'
    }
  },
  {
    path: '/pages/user/riskControl/RiskControl',
    name: 'RiskControl',
    component: RiskControl,
    meta: {
      navigationStyle: 'custom',
      title: 'Risk Control'
    }
  },
  {
    path: '/pages/user/memberInformation/update/ModifyNickname',
    name: 'ModifyNickname',
    component: ModifyNickname,
    meta: {
      navigationStyle: 'custom',
      title: 'Modify Nickname'
    }
  },
  {
    path: '/pages/user/memberInformation/update/ModifyRealname',
    name: 'ModifyRealname',
    component: ModifyRealname,
    meta: {
      navigationStyle: 'custom',
      title: 'Modify Realname'
    }
  },
  {
    path: '/pages/user/memberInformation/update/ModifyBank',
    name: 'ModifyBank',
    component: ModifyBank,
    meta: {
      navigationStyle: 'custom',
      title: 'Modify Bank'
    }
  },
  {
    path: '/pages/user/memberInformation/update/ModifyPhone',
    name: 'ModifyPhone',
    component: ModifyPhone,
    meta: {
      navigationStyle: 'custom',
      title: 'Modify Phone'
    }
  },
  {
    path: '/pages/user/memberInformation/update/ModifyEmail',
    name: 'ModifyEmail',
    component: ModifyEmail,
    meta: {
      navigationStyle: 'custom',
      title: 'Modify Email'
    }
  },
  {
    path: '/pages/user/memberInformation/update/ModifyLoginPassword',
    name: 'ModifyLoginPassword',
    component: ModifyLoginPassword,
    meta: {
      navigationStyle: 'custom',
      title: 'Modify Login Password'
    }
  },
  {
    path: '/pages/user/memberInformation/update/ModifyWithdrawPassword',
    name: 'ModifyWithdrawPassword',
    component: ModifyWithdrawPassword,
    meta: {
      navigationStyle: 'custom',
      title: 'Modify Withdraw Password'
    }
  },
  {
    path: '/pages/user/agency/Agency',
    name: 'Agency',
    component: Agency,
    meta: {
      navigationStyle: 'custom',
      title: 'Agency'
    }
  },
  {
    path: '/pages/user/agency/AgentDepot',
    name: 'AgentDepot',
    component: AgentDepot,
    meta: {
      navigationStyle: 'custom',
      title: 'Agent Depot'
    }
  },
  {
    path: '/pages/user/agency/AgentTransferWithdraw',
    name: 'AgentTransferWithdraw',
    component: AgentTransferWithdraw,
    meta: {
      navigationStyle: 'custom',
      title: 'Agent Transfer Withdraw'
    }
  },
  {
    path: '/pages/user/agency/AgencyLink',
    name: 'AgencyLink',
    component: AgencyLink,
    meta: {
      navigationStyle: 'custom',
      title: 'Agency Link'
    }
  },
  {
    path: '/pages/user/agency/MyTeam',
    name: 'MyTeam',
    component: MyTeam,
    meta: {
      navigationStyle: 'custom',
      title: 'My Team'
    }
  },
  {
    path: '/pages/user/agency/LowerLevelDepot',
    name: 'LowerLevelDepot',
    component: LowerLevelDepot,
    meta: {
      navigationStyle: 'custom',
      title: 'Lower Level Depot'
    }
  },
  {
    path: '/pages/user/friendCoupon/FriendCoupon',
    name: 'FriendCoupon',
    component: FriendCoupon,
    meta: {
      navigationStyle: 'custom',
      title: 'Friend Coupon'
    }
  },
  {
    path: '/pages/user/friendCoupon/FriendCouponTerms',
    name: 'FriendCouponTerms',
    component: FriendCouponTerms,
    meta: {
      navigationStyle: 'custom',
      title: 'Friend Coupon Terms'
    }
  },
  {
    path: '/pages/user/friendCoupon/FriendCouponQR',
    name: 'FriendCouponQR',
    component: FriendCouponQR,
    meta: {
      navigationStyle: 'custom',
      title: 'Friend Coupon QR'
    }
  },
  {
    path: '/pages/user/userCoupon/UserCoupon',
    name: 'UserCoupon',
    component: UserCoupon,
    meta: {
      navigationStyle: 'custom',
      title: 'User Coupon'
    }
  },
  {
    path: '/pages/home/NoticeDetailed',
    name: 'NoticeDetailed',
    component: NoticeDetailed,
    meta: {
      navigationStyle: 'custom',
      title: 'Notice Detailed'
    }
  },
  {
    path: '/pages/chat/ChatList',
    name: 'ChatList',
    component: ChatList,
    meta: {
      navigationStyle: 'custom',
      title: 'Chat List'
    }
  },
  {
    path: '/pages/chat/Chat',
    name: 'Chat',
    component: Chat,
    meta: {
      navigationStyle: 'custom',
      title: 'Chat'
    }
  },
  {
    path: '/pages/appdownload/AppDownload',
    name: 'AppDownload',
    component: AppDownload,
    meta: {
      navigationStyle: 'custom',
      title: 'App Download'
    }
  },
  {
    path: '/pages/user/redenvelope/RedEnvelope',
    name: 'RedEnvelope',
    component: RedEnvelope,
    meta: {
      navigationStyle: 'custom',
      title: 'Red Envelope'
    }
  },
  {
    path: '/pages/user/gxpay/Gxpay',
    name: 'Gxpay',
    component: Gxpay,
    meta: {
      navigationStyle: 'custom',
      title: 'Gxpay'
    }
  },
  {
    path: '/pages/backupAPIPage/backupapipage',
    name: 'BackupAPIPage',
    component: BackupAPIPage,
    meta: {
      navigationStyle: 'custom',
      title: 'Backup API Page'
    }
  },
  {
    path: '/pages/RiskNotice/RiskNotice',
    name: 'RiskNotice',
    component: RiskNotice,
    meta: {
      navigationStyle: 'custom',
      title: 'Risk Notice',
      transparent: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top when navigating to a new route
    return { top: 0, left: 0, behavior: 'instant' }
  }
})

// Make router available globally for navigation utility
router.beforeEach((to, from, next) => {
  // Store router instance globally for navigation utility
  if (typeof window !== 'undefined') {
    window.__VUE_ROUTER__ = router
  }
  // Use next() without arguments to avoid deprecation warnings
  next()
})

// Handle navigation errors globally to suppress warnings
const originalPush = router.push
const originalReplace = router.replace

router.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
  })
}

router.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
  })
}

export default router

